export enum RangeType {
    time = 0,
    distance = 1,
    pixels = 2,
    time389 = 3,
    timeCustomSpeed = 4,
    distanceRLOS = 5,
    distanceFobCurrentSpeed = 6,
    distanceFobCustomSpeed = 7
}
